module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_ny_qkl.595a430c.png";